/**
 * Utility functions for formatting data across the application
 */

/**
 * Generic status formatter that capitalizes words and replaces underscores with spaces
 */
export const formatStatus = (status: string): string => {
  if (!status) return "Unknown";

  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Specific status formatters for different entity types
 * These can be customized if different formatting is needed
 */
export const formatJobStatus = formatStatus;
export const formatQuoteStatus = formatStatus;
export const formatOrderStatus = formatStatus;

/**
 * Safely formats a date value for display
 * Handles null, undefined, empty strings, and invalid dates
 */
export const formatDate = (
  dateValue: string | Date | null | undefined,
): string => {
  if (!dateValue) return "No date";

  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (isNaN(date.getTime())) return "No date";

  // For date-only display, use UTC to avoid timezone shifts
  return date.toLocaleDateString("en-US", { timeZone: "UTC" });
};

/**
 * Safely formats a date and time value for display
 */
export const formatDateTime = (
  dateValue: string | Date | null | undefined,
): string => {
  if (!dateValue) return "No date";

  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  return isNaN(date.getTime())
    ? "No date"
    : `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
};
